import React from 'react';
import { CtaButton } from '../CtaButton';
import { OfferBlock } from '../OfferBlock';
import { systems } from '../../data/systems';
import { bonuses } from '../../data/bonuses';
export function ValueStack() {
  return <section id="offerta" className="border-b border-white/10 bg-ink-950" data-id="element-274" data-mp="1gs7xsew2rko4">
      <div className="mx-auto w-full max-w-xl px-4 py-12 sm:py-16 lg:max-w-3xl" data-id="element-275" data-mp="1btobgddkk6v8">
        <h2 className="text-center font-display text-[26px] uppercase leading-[1.1] text-white sm:text-3xl lg:text-[40px]" data-id="element-276" data-mp="o4lkgex1p1o2">
          Tutto quello che <span className="text-accent" data-id="element-277" data-mp="k4bdp01fi785">riceverai oggi</span>
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-white/10 bg-ink-800" data-id="element-278" data-mp="xuydywmu856c">
          <div className="border-b border-white/10 bg-white/[0.03] px-4 py-3 sm:px-6" data-id="element-279" data-mp="t36jwc4h3hbg">
            <h3 className="font-display text-sm uppercase tracking-wide text-white sm:text-base" data-id="element-280" data-mp="5e41h220lkfw">
              🔧 Sistema Tecnico PRO 360™
            </h3>
          </div>
          <ul className="divide-y divide-white/[0.07]" data-id="element-281" data-mp="cybhbzqoba2">
            {systems.map(system => <li key={system.number} className="flex items-start justify-between gap-3 px-4 py-3 sm:px-6" data-id="element-282" data-mp="2jny3usx3z0uv">
                <span className="text-[13.5px] leading-snug text-white/75 sm:text-[15px]" data-id="element-283" data-mp="2tflrsjughzrl">
                  <span className="font-semibold text-white" data-id="element-284" data-mp="2yf82aliwh1wp">Sistema #{Number(system.number)}</span>{' '}
                  · {system.title}
                </span>
                <span className="shrink-0 text-[13px] font-semibold text-white/45 line-through sm:text-sm" data-id="element-285" data-mp="20tj4v3asr871">
                  {system.price}
                </span>
              </li>)}
          </ul>

          <div className="border-y border-white/10 bg-accent/[0.07] px-4 py-3 sm:px-6" data-id="element-286" data-mp="2eqzbofx093zb">
            <h3 className="font-display text-sm uppercase tracking-wide text-accent sm:text-base" data-id="element-287" data-mp="2eomljfh3fnb6">
              Inoltre riceverai gratis
            </h3>
          </div>
          <ul className="divide-y divide-white/[0.07]" data-id="element-288" data-mp="3q4jklwinbnm4">
            {bonuses.map(bonus => <li key={bonus.title} className="flex items-start justify-between gap-3 px-4 py-3 sm:px-6" data-id="element-289" data-mp="1qztafo5b7mo2">
                <span className="text-[13.5px] leading-snug text-white/75 sm:text-[15px]" data-id="element-290" data-mp="202ko7ulnquiv">
                  <span aria-hidden="true" data-id="element-291" data-mp="1v37qget9031i">{bonus.emoji}</span>{' '}
                  {bonus.title.replace('SISTEMA ', 'Sistema ')}
                </span>
                <span className="shrink-0 text-[13px] font-semibold text-white/45 line-through sm:text-sm" data-id="element-292" data-mp="17dx0lsdfrt25">
                  {bonus.value}
                </span>
              </li>)}
          </ul>

          <dl className="space-y-2 border-t border-white/10 px-4 py-4 sm:px-6" data-id="element-293" data-mp="1h4hwh81q6jhd">
            <div className="flex items-center justify-between gap-3" data-id="element-294" data-mp="1cax4bwmtcjq3">
              <dt className="text-[13.5px] text-white/60 sm:text-sm" data-id="element-295" data-mp="om459raw9vr9">Sistema Tecnico PRO 360™</dt>
              <dd className="text-[13.5px] font-semibold text-white/60 sm:text-sm" data-id="element-296" data-mp="jokrstm0tn0d">442 €</dd>
            </div>
            <div className="flex items-center justify-between gap-3" data-id="element-297" data-mp="2va3ecbcisqs7">
              <dt className="text-[13.5px] text-white/60 sm:text-sm" data-id="element-298" data-mp="301mjg5lhmivj">5 Sistemi Premium</dt>
              <dd className="text-[13.5px] font-semibold text-white/60 sm:text-sm" data-id="element-299" data-mp="2magehtzfvt19">235 €</dd>
            </div>
            <div className="flex items-center justify-between gap-3 border-t border-white/10 pt-3" data-id="element-300" data-mp="2r9b1l84fw3r6">
              <dt className="font-display text-sm uppercase tracking-wide text-white sm:text-base" data-id="element-301" data-mp="3eylxab6xn7yg">
                Valore totale
              </dt>
              <dd className="font-display text-xl text-white/50 line-through sm:text-2xl" data-id="element-302" data-mp="3izxqeqp0mbbe">677 €</dd>
            </div>
          </dl>
        </div>

        <div className="mt-8 rounded-2xl border-2 border-accent bg-accent/[0.07] p-5 text-center sm:p-7" data-id="element-303" data-mp="39zsj0gjtncx8">
          <p className="font-display text-base uppercase leading-tight text-white sm:text-lg" data-id="element-304" data-mp="1tl9cum4ounbs">
            Ma oggi non pagherai 677 €.
            <span className="block text-accent" data-id="element-305" data-mp="1ymgm6pmhbukk">E nemmeno la metà.</span>
          </p>
          <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-white/50" data-id="element-306" data-mp="2dvk93k0xax45">
            Accesso immediato per soli
          </p>
          <p className="mt-1 font-display text-[64px] leading-none text-accent sm:text-7xl" data-id="element-307" data-mp="291z9jnjolv2u">19 €</p>
          <p className="mt-3 text-[13px] text-white/60 sm:text-sm" data-id="element-308" data-mp="24zumj7nqnwp6">
            Pagamento unico · Nessun abbonamento · Accesso a vita
          </p>

          <div className="mt-6 space-y-5" data-id="element-309" data-mp="2wsd2dga3bxyh">
            <CtaButton label="Voglio l’accesso immediato per 19 €" size="lg" data-id="element-310" data-mp="2wr239trlbedp" />
            <OfferBlock data-id="element-311" data-mp="2ssks8z51tjr0" />
          </div>
        </div>
      </div>
    </section>;
}